<template>

<div>
        
    <div class="row">
        <div class="col-12">
            <div class='alert alert-info'>
                <div>
                    <span>Конкурсът за {{ $parent.phase.name }} е приключил.</span>
                    <h4>Честито! Вие сте победител в този етап.</h4>
                    <p>Вашата награда е : {{ $store.state.ip.detiled.first_place }} лв.</p>
                </div>
            </div>
        </div>
    </div>

</div>


</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {

            return {
                
            }

        },

        methods : {

            getData() {
                
                var me = this;

            }

        },

        components : {
            
        }

    }
</script>
